var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",style:(_vm.setBg)},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})]),_c('div',{staticClass:"main-btn",on:{"click":function($event){return _vm.$router.push({ path: '/cata-h5' })}}})])}
var staticRenderFns = []

export { render, staticRenderFns }